import { instance as axios } from "../axios";

import {PRIVATE, PUBLIC} from '../variables'
import moment from 'moment';
import JWT from 'jsonwebtoken';

const TABLE = '/user/';

// initial state
const state = {
    session: false,
    user: null,
    links: {}
}

// getters
const getters = {
    getState:function(state){
        return state;
    },
    getLinks:(state)=>{
        return state.links
    }
}

// actions
const actions = {

    getData({ commit }, params) {
        return axios
            .post(TABLE+"get/"+token(params))
            .then(res => {
                if(res.data.results == 1) {
                    return decode(res.data.data).then((r)=>{
                        if(r) {
                            commit('setSessionData', r[0]);
                            return true;
                        }
                        else {
                            commit('setSessionData', null);
                            return false;
                        }
                    });
                }
                else {
                    commit('setSessionData', null);
                    return false;
                }
            })
            .catch(err => {
                commit('setSessionData', null);
                return false;
            });
        },
        
    signIn({ commit }, params) {
        return axios
        .post(TABLE+"login/"+token(params))
        .then(res => {
            if(res.data.results == 1) {
                return decode(res.data.data).then((r)=>{
                    if(r) {
                        commit('setSessionData', r[0]);
                        return true;
                    }
                    else {
                        commit('setSessionData', null);
                        return false;
                    }
                });
            }
            else {
                commit('setSessionData', null);
                return false;
            }
        })
        .catch(err => {
            commit('setSessionData', null);
            return false;
        });
    },

    update({ dispatch }, params) {
        return axios
            .put(TABLE+token(params))
            .then(res => {
                if(!res.data.errors) {
                    return true;
                }
                else return false;
            })
            .catch(err => {
                return false;
            });
    },

    setSessionData ({ commit }, data) {
        return commit('setSessionData', data)
    },

    setObra ({commit}, id) {
        return new Promise((resolve, reject) => {
            commit('setObra', id);
            resolve(true);
        });
    }
}

function token(params) {
    return JWT.sign({
        exp: Math.floor(Date.now() / 1000) + (60),
        data: params
    }, PRIVATE, { algorithm: 'RS256'});
}

function decode (token) {
    return new Promise(
        function (resolve, reject) {
          JWT.verify(token, PUBLIC, (err, decoded) => {
            if(err)resolve(false);
            else resolve(JWT.decode(token).data);
          });
        }
    );
}

// mutations
const mutations = {
    setSessionData(state, data) {
        if(data) {
            state.user = data;
    
            var SERVICE_API_IP = data.server.server_address;
            var obj = {
                serviceURL: SERVICE_API_IP + '/wscontabilidades/cntservice.asmx',
                extratoURL: SERVICE_API_IP + '/wscontabilidades/cntservice.asmx/DaExtratoConta',
                balanceteAURL: SERVICE_API_IP + '/wscontabilidades/cntservice.asmx/DaBalanceteAnalitico',
                balanceteRURL: SERVICE_API_IP + '/wscontabilidades/cntservice.asmx/DaBalanceteRazao',
                contasURL: SERVICE_API_IP + '/wscontabilidades/cntservice.asmx/DaContasCliente',
                rgURL: SERVICE_API_IP + '/wscontabilidades/cntservice.asmx/DaRelGestaoV2'
            }
            state.links = Object.assign({}, obj);

            state.session = true;

            if(state.user.super == 0) {
                state.user.anos = [];
                for(var i = Number(state.user.ano); i<=Number(moment().format('YYYY')); i++) {
                    state.user.anos.push(i);
                }
            }
        }
        else state.session = false;


    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/session.js